import { createContext, useContext } from "react";

const AccountContext = createContext();
const AccountProvider = AccountContext.Provider;
const useAccountContext = () => useContext(AccountContext);

export { AccountContext, AccountProvider, useAccountContext };
